// Critical-infrastructure layer helpers (global exposure overlay).

export const INFRA_META = {
  power_plant: { color: "#FBBF24", label: "Power plant" },
  city: { color: "#38BDF8", label: "Population center" },
};

export const fmtCapacity = (mw) =>
  mw >= 1000 ? `${(mw / 1000).toFixed(1)} GW` : `${Math.round(mw || 0)} MW`;

export const fmtPopulation = (n) =>
  n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${Math.round(n / 1e3)}k` : String(n || 0);
